module.exports = __webpack_public_path__ + "static/img/pin-trap-inactive.6b064a0.svg";